import React from "react";
import MUICheckbox from "@mui/material/Checkbox";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUIFormHelperText from "@mui/material/FormHelperText";
import { extractFormFieldError, getClassName } from "@sscs/utils";
import { Controller, useFormContext, } from "react-hook-form";
import { useControlSize } from "../formDense";
import { useRegisterRequiredField } from "../requiredFields";
import styles from "./checkbox.module.scss";
function Checkbox({ size, isRequired = false, isDisabled = false, className, ...props }) {
    const { control } = useFormContext();
    const resolvedSize = useControlSize(size);
    useRegisterRequiredField(isRequired);
    const { errorMessage, hasError } = extractFormFieldError(props.name, props === null || props === void 0 ? void 0 : props.errors);
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field: { ref, ...field } }) => (React.createElement("div", { className: getClassName(styles.root, className) },
            React.createElement(MUIFormControlLabel, { label: props.label, disabled: isDisabled, control: React.createElement(MUICheckbox, { ...field, checked: field.value, id: props.id, onChange: (event) => {
                        var _a;
                        field.onChange(event);
                        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
                    }, onBlur: () => {
                        var _a;
                        field.onBlur();
                        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props);
                    }, color: hasError ? "error" : "default", size: resolvedSize, slotProps: { input: { ref } }, required: isRequired, disabled: isDisabled }) }),
            props.helperText && (React.createElement(MUIFormHelperText, null, props.helperText)),
            hasError && (React.createElement(MUIFormHelperText, { error: true }, errorMessage)))) }));
}
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map